<div id="loader" *ngIf="visible" class="loader">
</div>
<div id="loader-backdrop" *ngIf="visible" class="loader-backdrop">
  <span *ngIf="supplementalInfoMessage && showSupplementalInfo" 
    style="position: fixed;left: 50%;top: 30%;transform: translate(-50%, -50%);margin-top: 120px;font-weight:bold;font-size:30px"
    class="ps-2 pe-2">
    {{supplementalInfoMessage}}
  </span>

</div>